<!------------------------------

      Page Actions

------------------------------->
<div *sbPageAction>
  <sb-button ngbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top" container="body"
             classes="btn-default actionButtonMinWidth" (click)="requestDebounced()" [disabled]="loading"
             [loading]="loading">
    <sb-icon icon="refresh"></sb-icon>
  </sb-button>
</div>
<!------------------------------

  side panel / Edit/Create

-------------------------------->

<sb-comp-side-panel (showChange)="showSideBar = $event" [show]="showSideBar" [sidebarHeader]="sidebarHeader"
                    [sidebarTemplate]="compSidePanelTemplate" [width]="500">

</sb-comp-side-panel>

<ng-template #sidebarHeader>
  <div class="d-flex">
    {{ "lang.globals.filter" |translate }}
  </div>
</ng-template>

<ng-template #compSidePanelTemplate>
  <div>
    <div class="mb-2">
      <div>{{ 'lang.globals.playerCull' | translate }}</div>
      <sb-comp-selection [display]="singleSelectedVerification?.playerCull"
                         (selectClicked)="selectCull('PlayerCull')"
                         (createClicked)="createCull('PlayerCull')"
                         (deleteClicked)="deleteCull('PlayerCull')">
      </sb-comp-selection>
    </div>
    <div class="mb-2">
      <div>{{ 'lang.globals.timeCull' | translate }}</div>
      <sb-comp-selection [display]="singleSelectedVerification?.timeCull"
                         (selectClicked)="selectCull('TimeCull')"
                         (createClicked)="createCull('TimeCull')"
                         (deleteClicked)="deleteCull('TimeCull')">
      </sb-comp-selection>
    </div>
    <div class="mb-2">
      <div>{{ 'lang.globals.geoCull' | translate }}</div>
      <sb-comp-selection [display]="singleSelectedVerification?.geoCull"
                         (selectClicked)="selectCull('GeoCull')"
                         (createClicked)="createCull('GeoCull')"
                         (deleteClicked)="deleteCull('GeoCull')">
      </sb-comp-selection>
    </div>
  </div>
  <div class="tw-flex tw-justify-between">
    <button type="button" class="btn btn-default" (click)="clearEdit()">{{ 'lang.globals.cancel' |translate }}</button>
    <sb-table-buttons>

      <ng-container *ngPermissions="permissionService.Permission.verification_verify">
        <a *ngIf="(isPending(singleSelectedVerification) || isRejected(singleSelectedVerification))"
           (click)="approveBooking(singleSelectedVerification)" class="btn btn-success" container="body"
           [ngbTooltip]="'lang.globals.approve' | translate">
          <sb-icon icon="boxChecked"></sb-icon>
        </a>
      </ng-container>
      <ng-container *ngPermissions="permissionService.Permission.verification_reject">
        <a *ngIf="(isPending(singleSelectedVerification) || isVerified(singleSelectedVerification))"
           (click)="rejectBooking(singleSelectedVerification)" class="btn btn-danger" container="body"
           ngbTooltip="{{'lang.globals.reject' | translate}}">
          <sb-icon icon="error"></sb-icon>
        </a>
      </ng-container>
    </sb-table-buttons>
  </div>
</ng-template>


<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper headline="{{headline}}" [itemsData]="verifications"
                  (filterChange)="requestDebounced()" [options]="options" (optionsChange)="requestDebounced($event)"
                  [loading]="loading" [itemName]="'verifications'">

  <!------------------------------

      Header More

  ------------------------------->
  <div header-more>
    <div class="d-flex align-items-center">

      <ng-container *ngIf="!multiSelect">
        <sb-radio-group
            [titles]="{Pending: 'lang.globals.pending' | translate, Rejected: 'lang.globals.rejected' | translate, Verified: 'lang.globals.verified' | translate }"
            [selections]="[PENDING, VERIFIED, REJECTED]" (selected)="selectedStatus($event)" [selectedVal]="type">
        </sb-radio-group>
      </ng-container>
      <div *ngIf="type === PENDING" class="mx-1">
        <a class="btn btn-primary" (click)="selectionState()">
          {{ 'lang.mediumExplorer.selectMedium'|translate }}
        </a>
      </div>
      <ng-container *ngIf="multiSelect">
        <a class="btn btn-success mx-1" (click)="acceptSelected()">
          {{ selected?.length > 0 ? selected?.length : '' }}&nbsp;{{ 'lang.globals.selectedAccept'|translate }}
        </a>
        <a class="btn btn-danger ml-1" (click)="rejectSelected()">
          {{ selected?.length > 0 ? selected?.length : '' }}&nbsp;{{ 'lang.globals.selectedReject'|translate }}
        </a>
        <a class="btn btn-secondary ml-1" (click)="selectAll()" [ngbTooltip]="'lang.globals.selectAll'|translate">
          <sb-icon icon="boxChecked"></sb-icon>
        </a>
        <a class="btn btn-secondary ml-1" (click)="deselectAll()" [ngbTooltip]="'lang.globals.deselectAll'|translate">
          <sb-icon icon="box"></sb-icon>
        </a>
      </ng-container>
    </div>
  </div>
  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>{{ 'lang.verification.permitted' | translate }}</th>
      <th>{{ 'lang.verification.motive' | translate }}</th>
      <th>{{ 'lang.globals.filter' | translate }}</th>
      <th>{{ 'lang.verification.advertiser' | translate }}</th>
      <th>{{ 'lang.globals.channel' | translate }}</th>
      <th>{{ 'lang.verification.verificationRequested' | translate }}</th>
      <th *ngIf="type === VERIFIED">{{ 'lang.verification.verificationGranted' | translate }}</th>
      <th *ngIf="type === REJECTED">{{ 'lang.verification.verificationRejected' | translate }}</th>
      <th class="text-end"></th>
    </tr>
  </ng-template>

  <!------------------------------

      Table Body

------------------------------->
  <ng-template #tbody let-verification>
    <tr>
      <td>
        <div class="tw-flex tw-gap-2">
          <sb-icon *ngIf="verification.permitted" class="green" icon="success"></sb-icon>
          <sb-icon *ngIf="!verification.permitted" class="red" icon="error"></sb-icon>
          <a *ngIf="type===REJECTED" [innerHTML]="verification?.reason | truncate : 35"
             (click)="showReason(verification)"></a>
        </div>
      </td>
      <td>
        <sb-comp-image-name-wrapper
            [background]="true"
            [hoverPreview]="true"
            [thumbnailSize]="'L'"
            [showFullOnClick]="true"
            [medium]="verification?.medium">
          <span firstLine [innerHtml]="verification?.medium?.name | truncate : 35"></span>
        </sb-comp-image-name-wrapper>
      </td>
      <td>
        <sb-comp-filter-overview [timeCull]="verification?.timeCull" [geoCull]="verification?.geoCull"
                                 [playerCull]="verification?.playerCull">
        </sb-comp-filter-overview>
      </td>
      <td>
        <sb-comp-image-name-wrapper [image]="verification?.advertiser?.primaryCompany?.logo?.url">
          <span firstLine [innerHTML]="verification?.advertiser?.name | truncate : 35"></span>
        </sb-comp-image-name-wrapper>
      </td>
      <td>
        <sb-comp-image-name-wrapper [image]="verification?.channel?.logo?.url">
          <span firstLine [innerHTML]="verification?.channel?.name | truncate : 20"></span>
          <span secondLine [innerHTML]="verification?.marker?.name | truncate : 20"></span>
        </sb-comp-image-name-wrapper>
      </td>
      <td>
        {{ verification?.createdAt.toString() | date : 'dd.MM.yy HH:mm' }}
      </td>
      <td *ngIf="type === VERIFIED">
        <a class="link cursor-help" container="body"
           [ngbTooltip]="('lang.verification.verifiedByUser'|translate:{user: verification?.verifiedBy?.name ? verification?.verifiedBy?.name : ('lang.globals.unknown'|translate)})"
           placement="top">{{ verification?.verifiedAt?.toString() | date: 'dd.MM.yy HH:mm:ss' }}</a>
      </td>
      <td *ngIf="type === REJECTED">
        <a class="link cursor-help" container="body"
           [ngbTooltip]="('lang.verification.rejectedByUser'|translate:{user: verification?.rejectedBy?.name ? verification?.rejectedBy?.name : ('lang.globals.unknown'|translate)})"
           placement="top">{{ verification?.rejectedAt?.toString() | date: 'dd.MM.yy HH:mm:ss' }}</a>
      </td>
      <td class="tr sticky-col last-col tableBg">
        <div class="tw-flex">
          <sb-table-buttons>
            <ng-container *ngIf="!multiSelect">

              <ng-container *ngPermissions="permissionService.Permission.verification_verify">
                <a *ngIf="(isPending(verification) || isRejected(verification))"
                   (click)="approveBooking(verification)" class="btn btn-success" container="body"
                   [ngbTooltip]="'lang.globals.approve' | translate">
                  <sb-icon icon="boxChecked"></sb-icon>
                </a>
              </ng-container>
              <ng-container *ngPermissions="permissionService.Permission.verification_reject">
                <a *ngIf="(isPending(verification) || isVerified(verification))"
                   (click)="rejectBooking(verification)" class="btn btn-danger" container="body"
                   ngbTooltip="{{'lang.globals.reject' | translate}}">
                  <sb-icon icon="error"></sb-icon>
                </a>
              </ng-container>
              <ng-container *ngPermissions="permissionService.Permission.verification_verify">
                <a *ngIf="LIFTREJECTIONALLOWED" (click)="liftRejection(verification)" container="body"
                   class="btn btn-success" ngbTooltip="{{'lang.globals.liftRejection' | translate}}">
                  <sb-icon icon="boxChecked"></sb-icon>
                </a>
              </ng-container>
              <ng-container *ngPermissions="permissionService.Permission.verification_reject">
                <a *ngIf="LIFTREJECTIONALLOWED" (click)="liftApproval(verification)" container="body"
                   class="btn btn-danger" ngbTooltip="{{'lang.globals.liftApproval' | translate}}">
                  <sb-icon icon="error"></sb-icon>
                </a>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="multiSelect">
              <a (click)="selectVerification(verification)"
                 class="btn btn-hover-primary"
                 container="body"
                 ngbTooltip="{{ 'lang.globals.select' | translate }}">
                <sb-icon *ngIf="checkSelection(verification) !== -1"
                         [icon]="'boxChecked'">
                </sb-icon>
                <sb-icon *ngIf="checkSelection(verification) === -1"
                         [icon]="'box'"
                ></sb-icon>
              </a>
            </ng-container>
          </sb-table-buttons>
          <button *ngIf="type === PENDING" type="button" class="btn btn-primary ml-2" (click)="toggleEdit(verification)"
                  [ngbTooltip]="'lang.globals.filter'|translate" container="body">
            <sb-icon icon="filter"></sb-icon>
          </button>
        </div>
      </td>
    </tr>
  </ng-template>
  <!------------------------------

    Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper>
